import { render, staticRenderFns } from "./UspResult.vue?vue&type=template&id=2d0b0280&scoped=true&"
import script from "./UspResult.vue?vue&type=script&lang=js&"
export * from "./UspResult.vue?vue&type=script&lang=js&"
import style0 from "./UspResult.vue?vue&type=style&index=0&id=2d0b0280&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b0280",
  null
  
)

export default component.exports